function b(n) {
  return n && typeof n == "object" && !Array.isArray(n) && n !== null;
}
function j(n, i) {
  if (b(n) && b(i))
    for (const f in i)
      b(i[f]) ? (n[f] || Object.assign(n, { [f]: {} }), j(n[f], i[f])) : Object.assign(n, { [f]: i[f] });
  return n;
}
export {
  b as isObject,
  j as mergeDeep
};
